import AirDatepicker from 'air-datepicker';
import 'air-datepicker/air-datepicker.css';

// Дополнительно для локализации (русский язык)
import localeRu from 'air-datepicker/locale/ru';

if(document.querySelector('.booking')) {
    // ========== КАЛЕНДАРЬ ==========
    const dateInput = document.querySelector('.booking__date');
    const calendarContainer = document.querySelector('#booking__calendar');
    
    if (dateInput && calendarContainer) {
        // Инициализация Air Datepicker
        const datepicker = new AirDatepicker(calendarContainer, {
            inline: true, // Всегда показывать календарь
            autoClose: false,
            dateFormat: 'dd MMMM yyyy',
            locale: {
                days: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
                daysShort: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
                daysMin: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
                months: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
                monthsShort: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
                today: 'Сегодня',
                clear: 'Очистить',
                dateFormat: 'dd MMM yyyy',
                firstDay: 1
            },
            minDate: new Date(), // Запрет прошедших дат
            onSelect: ({date, formattedDate}) => {
                if (dateInput) {
                    dateInput.value = formattedDate;
                }
            }
        });
        
        // Открытие/закрытие попапа календаря
        const dateLabel = dateInput.closest('.booking__label');
        const datePopup = dateLabel?.querySelector('.booking__popup');
        
        if (dateInput && datePopup) {
            dateInput.addEventListener('click', (e) => {
                // e.stopPropagation();
                // Закрыть другие попапы
                document.querySelectorAll('.booking__popup.active').forEach(popup => {
                    if (popup !== datePopup) popup.classList.remove('active');
                });
                datePopup.classList.toggle('active');
            });
            
            // Закрытие при клике вне попапа
            document.addEventListener('click', (e) => {
                if (!dateLabel.contains(e.target)) {
                    datePopup.classList.remove('active');
                }
            });
            
            // Предотвращение закрытия при клике внутри календаря
            datePopup.addEventListener('click', (e) => {
                // e.stopPropagation();
				e.preventDefault()
            });
        }
    }
    
    // ========== СЧЁТЧИКИ КОЛИЧЕСТВА ПОСЕТИТЕЛЕЙ ==========
    const countInput = document.querySelector('.booking__count');
    const counters = document.querySelectorAll('.booking__people-counter');
    
    // Функция для обновления общего количества
    function updateTotalCount() {
        const babyInput = document.querySelector('input[name="baby"]');
        const childInput = document.querySelector('input[name="child"]');
        const adultInput = document.querySelector('input[name="adult"]');
        
        const baby = parseInt(babyInput?.value) || 0;
        const child = parseInt(childInput?.value) || 0;
        const adult = parseInt(adultInput?.value) || 0;
        
        const total = baby + child + adult;
        
        if (countInput) {
            if (total === 0) {
                countInput.value = '';
            } else {
                countInput.value = `${total} ${getPeopleWord(total)}`;
            }
        }
    }
    
    // Функция для склонения слова "человек"
    function getPeopleWord(count) {
        if (count % 10 === 1 && count % 100 !== 11) return 'человек';
        if ([2, 3, 4].includes(count % 10) && ![12, 13, 14].includes(count % 100)) return 'человека';
        return 'человек';
    }
    
    // Функция для работы одного счётчика
    function initCounter(counterElement) {
        const minusBtn = counterElement.querySelector('.booking__people-counter-minus');
        const plusBtn = counterElement.querySelector('.booking__people-counter-plus');
        const input = counterElement.querySelector('.booking__people-counter-input');
        
        if (!minusBtn || !plusBtn || !input) return;
        
        // Установка начального значения
        if (!input.value || input.value === '') {
            input.value = '0';
        }
        
        // Минус
        minusBtn.addEventListener('click', () => {
            let currentValue = parseInt(input.value) || 0;
            if (currentValue > 0) {
                currentValue--;
                input.value = currentValue;
                updateTotalCount();
            }
        });
        
        // Плюс
        plusBtn.addEventListener('click', () => {
            let currentValue = parseInt(input.value) || 0;
            currentValue++;
            input.value = currentValue;
            updateTotalCount();
        });
        
        // Ручной ввод
        input.addEventListener('input', (e) => {
            let value = e.target.value.replace(/[^\d]/g, '');
            if (value === '') value = '0';
            let intValue = parseInt(value);
            if (intValue < 0) intValue = 0;
            e.target.value = intValue;
            updateTotalCount();
        });
        
        input.addEventListener('blur', () => {
            if (input.value === '' || parseInt(input.value) < 0) {
                input.value = '0';
                updateTotalCount();
            }
        });
    }
    
    // Инициализация всех счётчиков
    counters.forEach(counter => initCounter(counter));
    
    // ========== УПРАВЛЕНИЕ ПОПАПОМ КОЛИЧЕСТВА ==========
    const countLabel = countInput?.closest('.booking__label');
    const countPopup = countLabel?.querySelector('.booking__popup');
    
    if (countInput && countPopup) {
        countInput.addEventListener('click', (e) => {
            // e.stopPropagation();
            // Закрыть другие попапы
            document.querySelectorAll('.booking__popup.active').forEach(popup => {
                if (popup !== countPopup) popup.classList.remove('active');
            });
            countPopup.classList.toggle('active');
        });
        
        // Закрытие при клике вне попапа
        document.addEventListener('click', (e) => {

			
            if (countLabel && !countLabel.contains(e.target)) {
                countPopup.classList.remove('active');
            }
        });
        
        
    }
    
    // ========== ОБРАБОТКА ОТПРАВКИ ФОРМЫ ==========
    // const form = document.querySelector('form.booking');
    
    // if (form) {
    //     form.addEventListener('submit', (e) => {
    //         e.preventDefault();
            
    //         // Сбор данных формы
    //         const date = dateInput?.value || '';
    //         const baby = document.querySelector('input[name="baby"]')?.value || 0;
    //         const child = document.querySelector('input[name="child"]')?.value || 0;
    //         const adult = document.querySelector('input[name="adult"]')?.value || 0;
            
    //         // Валидация
    //         if (!date) {
    //             alert('Пожалуйста, выберите дату');
    //             dateInput?.focus();
    //             return;
    //         }
            
    //         const totalCount = parseInt(baby) + parseInt(child) + parseInt(adult);
    //         if (totalCount === 0) {
    //             alert('Пожалуйста, выберите количество посетителей');
    //             countInput?.focus();
    //             return;
    //         }
            
    //         // Формирование данных для отправки
    //         const formData = {
    //             date: date,
    //             baby: baby,
    //             child: child,
    //             adult: adult,
    //             total: totalCount
    //         };
            
    //         console.log('Отправка формы:', formData);
            
    //         // Здесь можно добавить отправку на сервер
    //         // fetch('index.html', {
    //         //     method: 'POST',
    //         //     headers: { 'Content-Type': 'application/json' },
    //         //     body: JSON.stringify(formData)
    //         // })
            
    //         alert(`Заказ оформлен!\nДата: ${date}\nМалыши: ${baby}\nДети: ${child}\nВзрослые: ${adult}\nВсего: ${totalCount} человек`);
            
    //         // Раскомментировать для реальной отправки
    //         // form.submit();
    //     });
    // }
    
    // Начальный подсчёт
    updateTotalCount();
}